module.exports = __webpack_public_path__ + "static/media/icon_search_off.eb1c83fe.svg";